export default __webpack_public_path__ + "static/resiland-logo-d9bb4a8720755073fcdb7308661b8802.svg";